import { useFormProps } from 'global/cnr/contexts/useHelpers/useFormProps';
import { useContext } from 'react';
import { Segment } from 'semantic-ui-react';
import { ActionContext } from '../../../cnr/contexts/ActionContext';
import { DataModifyContext } from '../../../cnr/contexts/DataModifyContext';
import { ParentContext } from '../../../cnr/contexts/ParentContext';
import { ViewSettingsComponentContext } from '../../../cnr/contexts/ViewSettingsComponentContext';
import { getFirstObject } from '../../../common/convert';
import { uniqueKey } from '../../../common/keys';
import ConfirmationQuestion from '../../../components/alerts/ConfirmationQuestion';
import FormForm from '../../../components/forms/FormForm';
import UploaderWithProvider from '../../../components/uploading/Uploader';
import { DataManagementContext } from '../../../components/viewers/DataManagementViewer';
import { clickOriginTypes, gEnums } from '../../../enums/globalEnums';
import MapListContent from '../../../viewSettings/create/createSubs/MapListContent';

/**
 * 
 * @param {object} props (modifyProps, subEditViewItem, lockedData, isDirect)
 * @returns a form based on the modifyProps and data_modified 
 * @description This is ONLY called from DataModifySwiper and ItemModifySidebar
 */
const DataItemModifyForm = (props) => {

  const { modifyData, modifyViewItem } = props

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { currentSettings_state } = states

  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});

  // pageContext 
  const { settingsOptions, display } = aps_global ?? {}
  let { useDarkMode } = settingsOptions ?? {}
  const { useSimpleInputs } = display ?? {}

  const { dataOptions } = aps_global ?? {}
  const { hideInputBorders } = dataOptions ?? {}

  // viewSettingsComponentContext 
  const viewSettingsComponentContext = useContext(ViewSettingsComponentContext);
  const { vsc_state } = viewSettingsComponentContext ?? {}
  const { swipedItem } = vsc_state ?? {}

  // dataManagementContext
  const dataManagementContext = useContext(DataManagementContext);
  const { dataManagement_state } = dataManagementContext ?? {}
  const { clickOriginType } = dataManagement_state ?? {}

  let _fromDataViewer;

  switch (clickOriginType) {
    case clickOriginTypes.dataViewer:
      _fromDataViewer = true
      break;
    default:
    //nothing
  }

  // dataModifyContext
  const dataModifyContext = useContext(DataModifyContext)
  const { dataModify_state, dataModify_handlers } = dataModifyContext ?? {}
  const { isDirect, lockedData, uploadOpen, questionProps: dataCommitData, data_modified, isList, dataListData, selectedKey } = dataModify_state ?? {}
  let { viewItem } = dataModify_state ?? {}

  if (modifyViewItem) { viewItem = modifyViewItem }

  const { item: firstData } = dataListData ? getFirstObject(dataListData) : {}
  let _modifyData = firstData ? firstData : data_modified
  if (modifyData) { _modifyData = modifyData }

  // actionContext    
  const actionContext = useContext(ActionContext);
  const { action_state, action_handlers } = actionContext ? actionContext : {}
  const { questionProps: actionCommitData } = action_state ? action_state : {}

  let _inverted = useDarkMode

  if (isDirect || selectedKey) { _inverted = false }
  if (!swipedItem) { _inverted = false }

  const { formProps, vit } = useFormProps(props)

  const confirmationQuestion = () => {
    const cd = dataCommitData ? dataCommitData : actionCommitData
    const y = dataCommitData ? dataModify_handlers.handleCommitYes : action_handlers.handleCommitYes
    const n = dataCommitData ? dataModify_handlers.handleCommitNo : action_handlers.handleCommitNo
    return <ConfirmationQuestion
      modalOpen={cd.check}
      handleYes={y}
      handleNo={n}
      header={cd.header}
      question={cd.question}
      asModal={false}
    />
  }

  let cn_form = 'form-container dm'
  if (useSimpleInputs || hideInputBorders) { cn_form += ' simp' }
  if (_fromDataViewer) { cn_form += ' app-dark-mode' }

  // THIS IS THE FORM
  const form = () => <Segment basic key={uniqueKey('form', 'div')} className={cn_form} inverted={_inverted}>
    <FormForm
      formAttributes={{ key: uniqueKey('form', 'form') }}
      formProps={formProps}
      swipedItem={swipedItem}
      isList={isList}
      showAll={true}
      lockedData={lockedData}
    />
  </Segment>

  const dataListForm = () => <div key={uniqueKey('form', 'div')} className={cn_form}>
    <MapListContent />
  </div>

  if (formProps) {
    if (uploadOpen) {
      return <UploaderWithProvider
        origin={'dataItemModify'}
        storageLocationType={gEnums.storageLocationTypes.event}
      />
    } else if ((dataCommitData && dataCommitData.check) || (actionCommitData && actionCommitData.check)) {
      return confirmationQuestion()
    } else {
      return isList ? dataListForm(formProps) : form(formProps)
    }
  }

  return <Segment loading inverted={_inverted}></Segment>

}

export default DataItemModifyForm